import { render, staticRenderFns } from "./bld-reviews.vue?vue&type=template&id=c0ca59bc&scoped=true&"
import script from "./bld-reviews.vue?vue&type=script&lang=js&"
export * from "./bld-reviews.vue?vue&type=script&lang=js&"
import style0 from "./bld-reviews.vue?vue&type=style&index=0&id=c0ca59bc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c0ca59bc",
  null
  
)

export default component.exports